module.exports = __webpack_public_path__ + "static/img/10areaA_09.cb81605.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/animal/10areaA_09.png
// module id = 795
// module chunks = 1